import React from 'react';
import { useProductStore } from "src/hooks/product";
import noImage from 'src/assets/images/noimage.png'
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { useSystem } from "src/hooks/system";

const PDPSellingProduct = (props) => {
    const { productDetail } = props
    const [{ }] = useProductStore();
    let { TopProducts } = productDetail;
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const [,{ get_quantity_format }] = useSystem();
    return (
        <>
            {TopProducts && TopProducts.length > 0 &&
                <div className='best-selling-product'>
                    <h3 className="mb-3 mt-0 lh-normal"> Best selling products</h3>
                    <div className='bs5 row d-flex align-items-stretch'>
                        {TopProducts.map((prod, index) => (
                            <div className='col-md-3 mb-3' key={index}>
                                <div className='best-selling-pro-box'>
                                    <div className='best-selling-img text-center mb-3'>
                                        <img src={prod.ImagePath ? prod.ImagePath : noImage} className="" />
                                    </div>
                                    <div className='best-selling-info'>
                                        <NavigateToProductDetail
                                            data={{ SEOManufacturerName: prod?.SEOManufacturerName, SEOERPMFRPartNumber: prod?.SEOERPMFRPartNumber, ItemNumber: prod?.ItemNumber, ERPPartNumber: prod?.ERPPartNumber }}>
                                            <div className='text-darkgreen font-14 font-arial'><b>{prod?.ERPMFRPartNumber}</b> </div>
                                        </NavigateToProductDetail>

                                        <p className='mb-0'><i>by {prod?.ManufacturerName}</i> </p>
                                        <p className='mt-0 mb-3 prod-desc'>{prod?.ShortDescription}</p>
                                        <table className='best-selling-table w-100 mb-3'>
                                            <thead>
                                                <tr>
                                                    <td>Price</td>
                                                    <td>Stock</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{Object.entries(get_pricing_by_id({ ItemNumber: prod.ItemNumber })).length > 0 ? `${window.mcs}${get_pricing_by_id({ ItemNumber: prod.ItemNumber })[0].marketPrice}` : "--"}</td>
                                                    <td>{get_quantity_format(get_inventory_by_id(prod.ItemNumber).inventoryQty)} <i className="fa fa-check-circle text-green"></i></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <NavigateToProductDetail
                                            data={{ SEOManufacturerName: prod?.SEOManufacturerName, SEOERPMFRPartNumber: prod?.SEOERPMFRPartNumber, ItemNumber: prod?.ItemNumber, ERPPartNumber: prod?.ERPPartNumber }}>
                                            <button className="bs5 btn btn-primary w-100">Buy</button>
                                        </NavigateToProductDetail>

                                    </div>
                                </div>
                            </div>
                        ))}


                    </div>
                </div>
            }
        </>
    );
}

export default PDPSellingProduct;